import { Injectable } from '@angular/core';
import { MenuState } from '../interfaces/menu-state';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  public active: MenuState = {
    type: 'default',
    menu: '',
    sub: '',
    tab: ''
  };
  public id: string = '';

  constructor() { }

  public setMenuType(type: string) {
    window.setTimeout(() => {
      this.active.type = type;
    });
  }

  public setMenuState(menu, sub, tab) {
    window.setTimeout(() => {
      this.active.menu = menu;
      this.active.sub = sub;
      this.active.tab = tab;
    });
  }
}
